import { render, staticRenderFns } from "./LicitacaoFornecedorDocumentosTabela.vue?vue&type=template&id=66adcd06"
import script from "./LicitacaoFornecedorDocumentosTabela.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorDocumentosTabela.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorDocumentosTabela.vue?vue&type=style&index=0&id=66adcd06&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports